'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _chart_utility = require('../../../../packages/common-utilities/src/chart_utility.js');

var _chart_utility2 = _interopRequireDefault(_chart_utility);

var _date_formatter = require('../../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chart_utility3 = require('../../../../packages/common-utilities/src/chart_utility');

var _formatted_number = require('../global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _number_utility = require('../../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _string_utility = require('../../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _moment = require('moment/moment');

var _moment2 = _interopRequireDefault(_moment);

var _ramda = require('ramda');

var _d = require('../../../../src/main/resources/static/vendor/scripts/firevis-1.0.1/dependencies/d3-4.2.6/d3.min');

var d3 = _interopRequireWildcard(_d);

var _collection_utility = require('common-utilities/src/collection_utility');

var _fund_utility = require('../../../../packages/common-utilities/src/fund_utility.js');

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _constants = require('../../../../packages/common-utilities/src/constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PerformanceChart = function (_React$Component) {
  _inherits(PerformanceChart, _React$Component);

  function PerformanceChart(props) {
    _classCallCheck(this, PerformanceChart);

    var _this = _possibleConstructorReturn(this, (PerformanceChart.__proto__ || Object.getPrototypeOf(PerformanceChart)).call(this, props));

    _this.trackChartHover = false;
    if (props.numberFormat === 'canadian') {
      d3.format = d3.formatLocale({
        decimal: ",",
        thousands: " ",
        grouping: [3]
      }).format;
    }
    return _this;
  }

  /* eslint-disable*/


  _createClass(PerformanceChart, [{
    key: 'createPerformanceChart',
    value: function createPerformanceChart(printWidth) {

      this.calculateHoverLabelValues();

      return (0, _chart_utility.generateChart)((0, _chart_utility3.generateChartId)("PerformanceChart", printWidth && typeof printWidth === "number"), "linechart", this.props.plotPoints, this.getChartConfiguration(printWidth));
    }
  }, {
    key: 'getChartConfiguration',
    value: function getChartConfiguration(printWidth) {
      var _this2 = this;

      var _props = this.props,
          currencyCode = _props.currencyCode,
          fundCurrencyCode = _props.fundCurrencyCode,
          yTicks = _props.yTicks,
          xTicks = _props.xTicks,
          dateOption = _props.dateOption,
          initialAmount = _props.initialAmount,
          breakpoint = _props.breakpoint,
          visibleDataPoints = _props.visibleDataPoints,
          intl = _props.intl;

      var formattedTicks = _chart_utility2.default.createTicksFormattedInD3DateFormat(xTicks);
      var firstXTick = formattedTicks[0];
      var marginLeft = breakpoint < 4 ? 77 : 85;
      var marginRight = breakpoint < 4 ? 0 : 20;
      var fontSize = this.props.country === 'au' ? "13px" : "12px";
      var rangePaddingRight = breakpoint < 4 ? "10" : "50";
      var shouldShowPercentageChangeInText = _collection_utility.CollectionUtility.includes(visibleDataPoints, 'PERFORMANCE_CHART_SHOW_SHARECLASS_NAV');
      var shouldShowBenchmarkPerformance = _collection_utility.CollectionUtility.includes(visibleDataPoints, 'PERFORMANCE_CHART_SHOW_BENCHMARK_PERFORMANCE') && this.props.plotPoints.filter(function (item) {
        return item.benchmarkAmount === 100;
      }).length !== this.props.plotPoints.length;
      var showSharePriceReturns = _collection_utility.CollectionUtility.includes(visibleDataPoints, 'PERFORMANCE_CHART_SHOW_SHAREPRICE_PERFORMANCE');
      var showRegularSavingAmount = _collection_utility.CollectionUtility.includes(visibleDataPoints, 'SHOW_REGULAR_SAVINGS_GROWTH_OF_HYPO_CHART');
      var showDateInLongFormat = _collection_utility.CollectionUtility.includes(this.props.formattingRules, 'PERFORMANCE_CHART_SHOW_DATE_IN_MMYYYY');
      var showApproxValueLabel = _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHOW_APPROX_VALUE_HYPOCHART');
      var showApproxPercentageInTooltip = _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'PERFORMANCE_CHART_SHOW_APPROX_PERCENTAGE_IN_TOOLTIP');
      var showDataPointLabels = _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'SHOW_DATA_POINT_LABELS_FOR_HYPOCHART');
      var shouldShowBenchmarkPerformanceEmea = (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'PERFORMANCE_CHART_SHOW_BENCHMARK_PERFORMANCE_EMEA') || _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'DAILY_ETF_FUND')) && this.props.plotPoints.filter(function (item) {
        return !(0, _ramda.isNil)(item.benchmarkAmount);
      }).length > 0;
      var toolTipTitleForEMEA = showApproxPercentageInTooltip ? _string_utility2.default.getLocalizedString(intl, 'Cumulative values ', 'pdp-perf-chart-cumulative-value-label') : _string_utility2.default.getLocalizedString(intl, 'Approx value ', 'pdp-perf-chart-approx-value-label');
      var colors = [_constants.CHART_COLORS.Pink];
      var values = ["amount"];
      if (shouldShowBenchmarkPerformance) {
        values.push("benchmarkAmount");
        colors.push(_constants.CHART_COLORS.Brown);
      }

      if (showSharePriceReturns) {
        values.push("sharePriceAmount");
        colors.push(_constants.CHART_COLORS.Green);
      }

      //Below is added as a separate condition to bring in 3rd graph in the chart with corresponding color
      if (shouldShowBenchmarkPerformanceEmea) {
        values.push("benchmarkAmount");
        colors.push(_constants.CHART_COLORS.Brown);
      }

      if (showRegularSavingAmount && !(0, _ramda.isNil)(this.props.plotPoints) && !(0, _ramda.isNil)(this.props.plotPoints[0].regularSavingAmount)) {
        values.push("regularSavingAmount");
        colors.push(_constants.CHART_COLORS.Blue);
      }

      var formattedDates = _collection_utility.CollectionUtility.reduce(this.props.plotPoints, function (map, value) {
        var date = void 0;
        if (shouldShowPercentageChangeInText) {
          date = (0, _moment2.default)(value.date, "YYYY-MM-DD").format('MM/YYYY');
        } else {
          date = _date_formatter2.default.getLocalFormattedDateForInjectIntl(value.date, _this2.props.intl);
        }

        map[value.date] = _extends({}, value, { formattedDate: date });
        return map;
      }, {});

      var navIncrease = '',
          benchmarkIncrease = '',
          sharepriceIncrease = '';

      var startDate = d3.timeParse("%Y-%m-%d")(this.props.plotPoints[0].date);
      var endDate = d3.timeParse("%Y-%m-%d")(this.props.plotPoints[this.props.plotPoints.length - 1].date);

      var spec = (0, _ramda.mergeDeepLeft)({
        "selector": "#PerformanceChart",
        "keys": ["date"],
        "values": values,
        "container": {
          "marginBottom": 50,
          "marginLeft": marginLeft,
          "marginRight": marginRight,
          "rangePaddingRight": rangePaddingRight
        },
        "scaled": true,
        "type": "line",
        "style": {
          "fill": colors
        },
        "colors": colors,
        "axis": {
          "x": {
            "show": true,
            "tick": {
              "padding": 5,
              "values": formattedTicks
            },
            "label": {
              "show": true,
              "text": function text(d) {
                if (d === firstXTick && dateOption === 0) {
                  return "";
                } else {
                  return showDateInLongFormat ? _date_formatter2.default.getDateInMonthYearFormatInMMYYYY(d) : _date_formatter2.default.getDateInMonthYearFormat(d);
                }
              },
              "style": {
                "font-family": "NBInternational",
                "font-size": fontSize
              }
            },
            "domain": [startDate, endDate]
          },
          "y": {
            "domain": [yTicks[0], yTicks[yTicks.length - 1]],
            "label": {
              "show": true,
              "style": {
                "font-family": "NBInternational",
                "font-size": fontSize
              },
              "text": function text(d) {
                if (d <= 0) {
                  return "";
                }
                if (d < 1000000) {
                  return currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(d), _this2.props.numberFormat);
                }
                if (d >= 1000000 && d < 1000000000) {
                  d = d / 1000000;
                  return currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",.1f")(d), _this2.props.numberFormat) + "M";
                }
                if (d >= 1000000000) {
                  d = d / 1000000000;
                  return currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",.1f")(d), _this2.props.numberFormat) + "B";
                }
              }
            },
            "tick": {
              "padding": 5,
              "grid": true,
              "style": {
                "stroke": "lightgrey"
              },
              "values": yTicks
            },
            "line": {
              "show": false
            }
          }
        },
        "hoverLine": {
          "tooltip": {
            "style": {
              "font-size": fontSize
            },
            "text": function text(data) {
              if (!_this2.trackChartHover) {
                _tracking_utility.TrackingUtility.trackEvent({
                  "eventCategory": _tracking_utility.TrackingUtility.getEventCategory("pdp"),
                  "eventAction": _this2.props.chartName,
                  "eventLabel": _tracking_utility.TrackingUtility.getEventLabel("chartHover")
                });
                _this2.trackChartHover = true;
              }
              var formattedItem = formattedDates[data.date];
              var formatteddateDisplay = showApproxValueLabel ? '' + toolTipTitleForEMEA + formattedItem.formattedDate : formattedItem.formattedDate;

              if (showApproxPercentageInTooltip) {
                navIncrease = " (" + formattedItem.amountPercentageInc + ")";
                benchmarkIncrease = " (" + formattedItem.benchmarkPercentageInc + ")";
                sharepriceIncrease = " (" + formattedItem.sharePricePercentageInc + ")";
              }

              if (shouldShowPercentageChangeInText) {
                var text = "<div style= 'text-align:left'>";

                var percentageChange = _string_utility2.default.getLocalizedString(intl, "% Change:", "pdp-performance-chart-percentage-change");
                text += "<div class='caption' style='font-weight:100'>" + formatteddateDisplay + "</div>";
                text += '<div style= \'text-align:left\' > <div style = \'width: 16px; height: 16px; border-radius: 50%; vertical-align: middle; background-color: ' + _constants.CHART_COLORS.Pink + ';  display: inline-block;\'> </div>  <span class=\'caption\' style=\'font-weight: 100; vertical-align: middle;\'>' + percentageChange + "</span> <span class='caption' style='font-weight: 400; vertical-align: middle;'>" + _number_utility2.default.convertToAmountWithPreciseRounding(formattedItem.shareclassHoverValue, (0, _fund_utility.isSGNonLiq)(_this2.props.country, _this2.props.role) ? 1 : 2, '-', false, true) + "</span> </div>";
                if (shouldShowBenchmarkPerformance) {
                  text += '<div style= \'text-align:left\'> <div style = \'width: 16px; height: 16px; border-radius: 50%; vertical-align: middle; background-color: ' + _constants.CHART_COLORS.Brown + '; display: inline-block;\'> </div>  <span class=\'caption font-light\' style=\'font-weight: 100; vertical-align: middle;\'>' + percentageChange + "</span> <span class='caption' style='font-weight: 400; vertical-align: middle;'>" + _number_utility2.default.convertToAmountWithPreciseRounding(formattedItem.benchmarkHoverValue, (0, _fund_utility.isSGNonLiq)(_this2.props.country, _this2.props.role) ? 1 : 2, '-', false, true) + "</span> </div>";
                }
                if (showRegularSavingAmount && data.regularSavingAmount != null) {
                  var savingsLabel = _string_utility2.default.getLocalizedString(intl, "SAVINGS", "pdp-perf-chart-regular-saving-amount-tooltip-label");
                  text += '<div style= \'text-align:left\'> <div style=\'width: 16px; height: 16px; border-radius: 50%; vertical-align: middle; background-color: ' + _constants.CHART_COLORS.Blue + '; display: inline-block;\'> </div>  <span class=\'caption font-regular\' style=\'font-weight: 100; vertical-align: middle;\'>' + savingsLabel + "</span> <span class='caption' style='font-weight: 400; vertical-align: middle;'>" + currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(data.regularSavingAmount), _this2.props.numberFormat) + "</span> </div>";
                }
                text += "</div>";
                return text;
              } else if (showSharePriceReturns) {
                var _text = "<div style= 'text-align:left'>";

                var navLabel = _string_utility2.default.getLocalizedString(intl, "NAV:", "pdp-performance-chart-nav-tooltip");
                var sharPriceLabel = _string_utility2.default.getLocalizedString(intl, "Share Price:", "pdp-performance-chart-nav-tooltip");
                var benchmarkLabel = _string_utility2.default.getLocalizedString(intl, "Benchmark:", "pdp-performance-chart-benchmark-tooltip", { role: _this2.props.role });

                _text += "<div class='caption' style='font-weight:100; padding-bottom: 2px;'>" + formatteddateDisplay + "</div>";
                _text += '<div style= \'text-align:left\'> <div style = \'width: 16px; height: 16px; border-radius: 50%; vertical-align: middle; background-color: ' + _constants.CHART_COLORS.Pink + '; display: inline-block;\'> </div>  <span class=\'font-regular\' style=\'font-weight: 100; vertical-align: middle;\'>' + navLabel + "</span> <span class='caption' style='font-weight: 400; vertical-align: middle;'>" + currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(data.amount), _this2.props.numberFormat) + navIncrease + "</span> </div>";
                _text += '<div style= \'text-align:left\'> <div style = \'width: 16px; height: 16px; border-radius: 50%; vertical-align: middle; background-color: ' + _constants.CHART_COLORS.Green + '; display: inline-block;\'> </div>  <span class=\'caption font-regular\' style=\'font-weight: 100; vertical-align: middle;\'>' + sharPriceLabel + "</span> <span class='caption' style='font-weight: 400; vertical-align: middle;'>" + currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(data.sharePriceAmount), _this2.props.numberFormat) + sharepriceIncrease + "</span> </div>";
                if (shouldShowBenchmarkPerformanceEmea) {
                  _text += '<div style= \'text-align:left\'> <div style=\'width: 16px; height: 16px; border-radius: 50%; vertical-align: middle; background-color: ' + _constants.CHART_COLORS.Brown + '; display: inline-block;\'> </div>  <span class=\'caption font-regular\' style=\'font-weight: 100; vertical-align: middle;\'>' + benchmarkLabel + "</span> <span class='caption' style='font-weight: 400; vertical-align: middle;'>" + currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(data.benchmarkAmount), _this2.props.numberFormat) + benchmarkIncrease + "</span> </div>";
                }
                if (showRegularSavingAmount && data.regularSavingAmount != null) {
                  var _savingsLabel = _string_utility2.default.getLocalizedString(intl, "SAVINGS", "pdp-perf-chart-regular-saving-amount-tooltip-label");
                  _text += '<div style= \'text-align:left\'> <div style=\'width: 16px; height: 16px; border-radius: 50%; vertical-align: middle; background-color: ' + _constants.CHART_COLORS.Blue + '; display: inline-block;\'> </div>  <span class=\'caption font-regular\' style=\'font-weight: 100; vertical-align: middle;\'>' + _savingsLabel + "</span> <span class='caption' style='font-weight: 400; vertical-align: middle;'>" + currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(data.regularSavingAmount), _this2.props.numberFormat) + "</span> </div>";
                }

                _text += "</div>";
                return _text;
              } else if (showDataPointLabels) {
                var _text2 = "<div style= 'text-align:left'>";
                var dataPointLabel = _string_utility2.default.getLocalizedString(intl, "", "pdp-performance-chart-fund-hover-box", { fundType: _this2.props.fundTypeCode });
                var _benchmarkLabel = _string_utility2.default.getLocalizedString(intl, "Benchmark:", "pdp-performance-chart-benchmark-tooltip", { role: _this2.props.role });
                _text2 += "<div class='caption' style='font-weight:100'>" + formatteddateDisplay + "</div>";
                _text2 += '<div class=\'caption\' style=\'font-weight:400;\'><div style = \'width: 16px; height: 16px; border-radius: 50%; vertical-align: middle; background-color: ' + _constants.CHART_COLORS.Pink + '; display: inline-block;\'> </div><span class=\'caption font-regular\' style=\'font-weight: 400; vertical-align: middle;\'> ' + dataPointLabel + " </span> <span class='caption font-regular' style='font-weight: 400; vertical-align: middle;'>" + currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(data.amount), _this2.props.numberFormat) + navIncrease + "</span></div>";
                if (shouldShowBenchmarkPerformanceEmea) {
                  var displayBenchmarkCurrencyLabel = _collection_utility.CollectionUtility.includes(_this2.props.formattingRules, 'BENCHMARK_CODE_DISPLAY_FUND_CURRENCY') ? fundCurrencyCode : currencyCode;
                  _text2 += '<div style= \'text-align:left\'> <div style=\'width: 16px; height: 16px; border-radius: 50%; vertical-align: middle; background-color: ' + _constants.CHART_COLORS.Brown + '; display: inline-block;\'> </div>  <span class=\'caption font-regular\' style=\'font-weight: 100; vertical-align: middle;\'>' + _benchmarkLabel + "</span> <span class='caption' style='font-weight: 400; vertical-align: middle;'>" + displayBenchmarkCurrencyLabel + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(data.benchmarkAmount), _this2.props.numberFormat) + benchmarkIncrease + "</span> </div>";
                }
                if (showRegularSavingAmount && data.regularSavingAmount != null) {
                  var _savingsLabel2 = _string_utility2.default.getLocalizedString(intl, "SAVINGS", "pdp-perf-chart-regular-saving-amount-tooltip-label");
                  _text2 += '<div style= \'text-align:left\'> <div style=\'width: 16px; height: 16px; border-radius: 50%; vertical-align: middle; background-color: ' + _constants.CHART_COLORS.Blue + '; display: inline-block;\'> </div>  <span class=\'caption font-regular\' style=\'font-weight: 100; vertical-align: middle;\'>' + _savingsLabel2 + "</span> <span class='caption' style='font-weight: 400; vertical-align: middle;'>" + currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(data.regularSavingAmount), _this2.props.numberFormat) + "</span> </div>";
                }
                if (data.amount === initialAmount && dateOption === 0) {
                  d3.select(".firevis-tooltip").style("display", "none");
                } else {
                  d3.select(".firevis-tooltip").style("display", "block");
                }
                _text2 += "</div>";
                return _text2;
              } else {
                var _text3 = "<div style= 'text-align:left'>";

                _text3 += "<div class='caption' style='font-weight:100'>" + formatteddateDisplay + "</div>";
                _text3 += "<div class='caption' style='font-weight:400'>" + currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",")(data.amount), _this2.props.numberFormat) + "</div>";
                if (data.amount === initialAmount && dateOption === 0) {
                  d3.select(".firevis-tooltip").style("display", "none");
                } else {
                  d3.select(".firevis-tooltip").style("display", "block");
                }
                _text3 += "</div>";
                return _text3;
              }
            }
          }
        },
        "postProcessing": function postProcessing(chart, data) {
          if (!(0, _ramda.isNil)(_this2.props.benchmarkRestructuringDate) && _collection_utility.CollectionUtility.includes(visibleDataPoints, 'PERFORMANCE_CHART_SHOW_RE_STRUCTURING_LINE') && (0, _moment2.default)(_this2.props.benchmarkRestructuringDate).isSameOrAfter(_this2.props.plotPoints[0].date)) {
            var dateToArray = _this2.props.benchmarkRestructuringDate.split("-");
            var year = dateToArray[0];
            var month = dateToArray[1];
            var date = dateToArray[2];
            var xPlotPoint = chart.getXScale()(new Date(year, month, date)) + chart.getMarginLeft();

            chart.getSVG().append("line").attr("x1", xPlotPoint).attr("y1", chart.getMarginTop()).attr("x2", xPlotPoint).attr("y2", chart.getPlotHeight() + chart.getMarginBottom() / 2).style("stroke", _constants.CHART_COLORS.Blue).style("stroke-width", 2);
          }
          if (_collection_utility.CollectionUtility.includes(visibleDataPoints, 'SHOW_REGULAR_SAVINGS_GROWTH_OF_HYPO_CHART')) {

            var _data = chart.getData();
            if (_data[0].regularSavingAmount != null) {
              var area = d3.area().x(function (d) {
                return chart.getXScale()(d.date);
              }).y0(chart.getYScale()(initialAmount)).y1(function (d) {
                return chart.getYScale()(d.regularSavingAmount);
              });

              chart.getSVG().select("g").insert("path", "g").attr("d", area(_data)).attr("fill", _constants.CHART_COLORS.Blue);
            }
          }
          chart.getPlot().selectAll(".tick line").style("stroke", "lightgrey");
        }
      }, _chart_utility3.COMMON_CHART_CONFIG);

      if (printWidth && typeof printWidth === "number") {
        spec.container.width = (0, _chart_utility3.getChartPrintWidth)();
        spec.container.height = (0, _chart_utility3.getChartPrintHeight)();
      }

      return spec;
    }
  }, {
    key: 'calculateHoverLabelValues',
    value: function calculateHoverLabelValues() {
      for (var i = 0; i < this.props.plotPoints.length; i++) {
        if (this.props.fundTypeCode === "Mainland_HK_MRF_FUNDS") {
          this.props.plotPoints[i].benchmarkHoverValue = this.props.plotPoints[i].benchmarkAmount;
          this.props.plotPoints[i].shareclassHoverValue = this.props.plotPoints[i].amount;
        } else {
          if (i == 0) {
            this.props.plotPoints[i].benchmarkHoverValue = 0;
            this.props.plotPoints[i].shareclassHoverValue = 0;
          } else {
            this.props.plotPoints[i].benchmarkHoverValue = this.props.plotPoints[i].benchmarkAmount - 100;
            this.props.plotPoints[i].shareclassHoverValue = this.props.plotPoints[i].amount - 100;
          }
        }
      }
      return this.props.plotPoints;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.plotPoints.length === 0) {
        return null;
      }
      var performanceChart = this.createPerformanceChart();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'print-hide' },
          _react2.default.createElement(performanceChart)
        ),
        _react2.default.createElement(
          'div',
          { className: 'print-display', style: { display: "none" } },
          _react2.default.createElement(this.createPerformanceChart(800))
        )
      );
    }
  }]);

  return PerformanceChart;
}(_react2.default.Component);

/* eslint-enable*/


exports.default = PerformanceChart;